import { Navigate, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { JSX } from "react";
import { useStore } from "stores/useStore";

interface Props {
  children: JSX.Element;
  allowedRoles?: string[];
}

const PrivateRouteRedirection = observer(
  ({ children, allowedRoles }: Props) => {
    const { authStore } = useStore();
    const location = useLocation();

    if (!authStore?.isAuthenticated()) {
      authStore.resetLogoutFlag();
      return <Navigate to="/" state={{ from: location }} replace />;
    } else if (
      allowedRoles &&
      authStore?.user?.role &&
      !allowedRoles.includes(authStore?.user?.role)
    ) {
      return <Navigate to="/dashboard" replace />;
    }

    return children;
  }
);

export default PrivateRouteRedirection;
